import awsExports from 'aws-exports';
import { create } from 'zustand';

export const useAppProviderStore = create(set => ({
  cognitoUserChangePassword: {},
  setCognitoUserChangePassword: value =>
    set({ cognitoUserChangePassword: value }),
  inputEmailForgotPassword: {},
  setinputEmailForgotPassword: value =>
    set({ inputEmailForgotPassword: value }),
  thumbUrl: awsExports.ENDPOINT_THUMBNAIL,
  ENDPOINT_ADMIN: awsExports.ENDPOINT_ADMIN,
  API_KEY: awsExports.API_KEY,
  transcoder: {},
  isLoading: false,
  setIsLoading: value => set({ isLoading: value }),
  setTranscoder: value => set({ transcoder: value }),
  openTranscoder: false,
  setOpenTranscoder: value => set({ openTranscoder: value }),
  videoMainUploadProgress: undefined,
  setVideoMainUploadProgress: value => set({ videoMainUploadProgress: value }),
  videoMainUploadComplete: false,
  setVideoMainUploadComplete: value => set({ videoMainUploadComplete: value }),
  audioMainUploadProgress: undefined,
  setAudioMainUploadProgress: value => set({ audioMainUploadProgress: value }),
  audioTrailerUploadProgress: false,
  setAudioTrailerUploadProgress: value =>
    set({ audioTrailerUploadProgress: value }),
  subtitleMainUploadProgress: undefined,
  setSubtitleMainUploadProgress: value =>
    set({ subtitleMainUploadProgress: value }),
  videoAcessibilityUploadProgress: undefined,
  setVideoAcessibilityUploadProgress: value =>
    set({ videoAcessibilityUploadProgress: value }),
  videoTrailerUploadProgress: undefined,
  setVideoTrailerUploadProgress: value =>
    set({ videoTrailerUploadProgress: value }),
  trailerUploadProgress: undefined,
  setTrailerUploadProgress: value => set({ trailerUploadProgress: value }),
  legendaAccessibilityUploadProgress: false,
  setLegendaAccessibilityUploadProgress: value =>
    set({ legendaAccessibilityUploadProgress: value }),
  legendaTrailerUploadProgress: false,
  setLegendaTrailerUploadProgress: value =>
    set({ legendaTrailerUploadProgress: value }),
  activeStep: 1,
  setActiveStep: value =>
    set(state => ({
      activeStep: typeof value === 'function' ? value(state.activeStep) : value,
    })),
  mainUploaded: false,
  setMainUploaded: value => set({ mainUploaded: value }),
  trailerUploaded: false,
  setTrailerUploaded: value => set({ trailerUploaded: value }),
  accessibilityUploaded: false,
  setAccessibilityUploaded: value => set({ accessibilityUploaded: value }),
  cancelUpload: false,
  setCancelUpload: value => set({ cancelUpload: value }),
  videoResponse: {},
  setVideoResponse: value => set({ videoResponse: value }),
  notify: { isOpen: false },
  setNotify: value => set({ notify: value }),
}));
